// src/features/dashboard/Routes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import DashboardPage from './pages/DashboardPage';

export const DashboardRoutes = () => (
  <Route
    path="dashboard"
    element={
      <ProtectedRoute requiredScope="task:read">
        <DashboardPage />
      </ProtectedRoute>
    }
  />
);
